"use client";


// src/libraries/react/hooks/useEntityBase.tsx
import useSWR from "swr";
import { useContext } from "react";
var useEntityBase = ({
  entityId,
  params,
  AutumnContext
}) => {
  const { client } = useContext(AutumnContext);
  const queryKey = ["entity", entityId, params?.expand];
  const fetchEntity = async () => {
    if (!entityId) {
      return null;
    }
    const { data: data2, error: error2 } = await client.entities.get(entityId, params);
    if (error2) {
      throw error2;
    }
    if (!data2) {
      return null;
    }
    return data2;
  };
  const { data, error, isLoading, mutate } = useSWR(queryKey, fetchEntity, {
    fallbackData: null,
    onErrorRetry: (error2, key, config) => {
      if (error2.code == "entity_not_found") {
        return false;
      }
      return true;
    }
  });
  if (!entityId) {
    return {
      entity: null,
      isLoading: false,
      error: null,
      refetch: mutate
    };
  }
  return {
    entity: error ? null : data,
    isLoading,
    error,
    refetch: mutate
  };
};

export {
  useEntityBase
};
